import PropTypes from 'prop-types';
import LinkImage from '../../assets/images/Link.png';
import ShowDoneIconOnSelect from '../../icons/ShowDoneIconOnSelect';
import { Body3 } from '../../themes/typography';
import '../../styles/components/PlatformCard.css';

function PlatformCard({
    img = LinkImage,
    platformName = 'Other',
    isSelected = true,
    onCardClick = () => {},
    style
}) {
    return (
        <div
            className={`platform-card-container ${isSelected ? 'selected' : ''}`}
            onClick={onCardClick}
            style={style}
        >
            <div className="platform-image-container">
                <div className="platform-image">
                    <img src={img} alt={platformName} />
                </div>
            </div>
            <div className="platform-name">
                <Body3 fontWeight={400}>{platformName}</Body3>
            </div>
            {isSelected && <ShowDoneIconOnSelect />}
        </div>
    );
}

export default PlatformCard;

// Proptypes validatioon
PlatformCard.propTypes = {
    img: PropTypes.string,
    platformName: PropTypes.string,
    onCardClick: PropTypes.func
};
